import api from '../httpClient';
import type {
  AdminAnalyticsDashboardData,
  AdminAnalyticsFiltersResponse,
  AdminAnalyticsUsersResponse,
} from '../../types';

export interface AdminAnalyticsQueryParams {
  start_date: string;
  end_date: string;
  organization_ids?: string[];
  cohort_ids?: string[];
  flow_ids?: string[];
  search?: string;
  include_staff?: boolean;
  page?: number;
  page_size?: number;
  sort?: string;
}

const buildParams = (params: AdminAnalyticsQueryParams) => ({
  start_date: params.start_date,
  end_date: params.end_date,
  ...(params.organization_ids?.length ? { organization_ids: params.organization_ids } : {}),
  ...(params.cohort_ids?.length ? { cohort_ids: params.cohort_ids } : {}),
  ...(params.flow_ids?.length ? { flow_ids: params.flow_ids } : {}),
  ...(params.search ? { search: params.search } : {}),
  ...(typeof params.include_staff === 'boolean' ? { include_staff: params.include_staff } : {}),
  ...(typeof params.page === 'number' ? { page: params.page } : {}),
  ...(typeof params.page_size === 'number' ? { page_size: params.page_size } : {}),
  ...(params.sort ? { sort: params.sort } : {}),
});

export const adminAnalytics = {
  getFilters: () =>
    api
      .get<AdminAnalyticsFiltersResponse>('/api/admin/analytics/filters/')
      .then((response) => response.data),
  getDashboard: (params: AdminAnalyticsQueryParams) =>
    api
      .get<AdminAnalyticsDashboardData>('/api/admin/analytics/dashboard/', {
        params: buildParams(params),
      })
      .then((response) => response.data),
  getUsers: (params: AdminAnalyticsQueryParams) =>
    api
      .get<AdminAnalyticsUsersResponse>('/api/admin/analytics/users/', {
        params: buildParams(params),
      })
      .then((response) => response.data),
  exportUsers: (params: AdminAnalyticsQueryParams) =>
    api.get('/api/admin/analytics/export/users/', {
      params: buildParams(params),
      responseType: 'blob',
    }),
  exportDashboard: (params: AdminAnalyticsQueryParams) =>
    api.get('/api/admin/analytics/export/dashboard/', {
      params: buildParams(params),
      responseType: 'blob',
    }),
};
